interface ThrownError {
    columnNumber: number,
    fileName: string,
    lineNumber: number,
    message: string,
    stack?: string
}

export function getStackTrace(error: ThrownError) : string {
    let stack = [];
    if (error.stack) {
        stack = error.stack.split('\n').
            map(function (line) { return line.trim(); });
    }
    return stack.join('\n');
}